import { Controller } from "@hotwired/stimulus"
import { Popover } from "bootstrap"

export default class extends Controller {
  static values = {
    content: String,
    placement: { type: String, default: 'top' }
  }

  connect() {
    this.popover = new Popover(this.element, {
      trigger: 'hover focus',
      html: false,
      placement: this.placementValue,
      content: this.contentValue || '',
      // These are plain-text hints, never interactive — tag them so they can't
      // swallow a click on what they overlap. A bottom-placed hint on a dropdown
      // toggle (e.g. the editor's background-colour picker) sits right over the menu
      // that unfolds under it. See `.popover--hint` in components/popovers.scss.
      customClass: 'popover--hint'
    })
  }

  disconnect() {
    this.popover?.dispose()
  }
}
